module.exports = new __parcel__URL__("recruitment_ja.e99a7702.webp").toString();